import React, {
  createContext,
  useEffect,
  useState,
  useContext,
  useCallback,
} from 'react';
import api from '../services/api';
import { ICompany } from '../shared/interfaces';

interface CompanyContextData {
  company: ICompany | null;
  updateCompany(company: ICompany): void;
}

const CompanyContext = createContext<CompanyContextData>(
  {} as CompanyContextData,
);

interface ICompanyProvider {
  children: any;
}

const CompanyProvider: React.FC<ICompanyProvider> = ({ children }) => {
  const [company, setCompany] = useState<ICompany | null>(null);

  const updateCompany = useCallback((company: ICompany) => {
    setCompany(company);
  }, []);

  useEffect(() => {
    const token = sessionStorage.getItem('@Sigeclin:token');
    const clinic = sessionStorage.getItem('@Sigeclin:clinic');
    if (!token || !clinic || clinic === '0') return;
    api
      .get(`/company/find`)
      .then((response: any) => {
        if (response.data) {
          setCompany(response.data);
        }
      })
      .catch(() => console.log('Error to find company'));
  }, []);

  return (
    <CompanyContext.Provider value={{ company, updateCompany }}>
      {children}
    </CompanyContext.Provider>
  );
};

function useCompany(): CompanyContextData {
  const context = useContext(CompanyContext);

  if (!context) {
    throw new Error('useCompany must be used within a CompanyProvider');
  }

  return context;
}

export { CompanyProvider, useCompany };
